import { INode } from 'shared/types/tree'
import { createContext, useContext } from 'react'

type ImageVerificationData = {
  tree: INode
  externalUrls: string[]
  internalUrls: string[]
  dataSrcs: string[]
  onTreeUpdate(): void
}

export const ImageVerificationContext = createContext<
  ImageVerificationData | undefined
>(undefined)

export const useImageVerificationContext = (): ImageVerificationData => {
  const contextData = useContext(ImageVerificationContext)
  if (!contextData) {
    throw new Error('No ImageVerificationContext founc')
  }
  return contextData
}
